module.exports = __webpack_public_path__ + "static/media/DRAX-logoolg.963ea7c4.png";